import * as types from './mutations_types'

export const setTemplates = (context, items) => context.commit(types.SET_TEMPLATES, items)

export const saveTemplate = (context, item) => context.commit(types.SAVE_TEMPLATE, item)

export const destroyTemplate = (context, id) => context.commit(types.DESTROY_TEMPLATE, id)

export const selectTemplate = (context, item) => context.commit(types.SELECT_TEMPLATE, item)

export const clearTemplate = (context) => context.commit(types.CLEAR_TEMPLATE)



// WEBPACK FOOTER //
// ./src/modules/templates/store/actions.js